import React from 'react';
import ABSMessage from '../ABSMessage';
import { defaultResult, validatorWithMsg } from '../../utils/Validator';
import _ from 'lodash';
import { ABSSelectView } from './ABSSelectView';
import { IABSSelectProps } from './interface';
import commonUtils from '../../utils/commonUtils';

export interface IABSSelectState {
  value?: any;
  result?: any;
}

class ABSSelect extends React.Component<IABSSelectProps, IABSSelectState> {
  public static defaultProps = {
    multipleMaxNum: 1,
    rules: []
  };

  constructor(props: IABSSelectProps) {
    super(props);
    const { defaultValue, mode } = props;
    if (!commonUtils.hasValue(props, 'value')) {
      if (mode) {
        this.state = {
          value: defaultValue || [],
          result: defaultResult
        };
      } else {
        this.state = {
          value: !defaultValue && defaultValue !== 0 && defaultValue !== false ? undefined : defaultValue,
          // defaultValue === undefined || defaultValue === null
          //   ? ''
          //   : defaultValue,
          result: defaultResult
        };
      }
    } else {
      this.state = {
        result: defaultResult
      };
    }
  }

  componentWillReceiveProps(nextProps: IABSSelectProps) {
    const { defaultValue, mode } = nextProps;
    if (!commonUtils.hasValue(nextProps, 'value')) {
      if (mode) {
        if (defaultValue !== this.props.defaultValue) {
          this.setState({
            value: defaultValue || [],
            result: defaultResult
          });
        }
      } else {
        if (defaultValue !== this.props.defaultValue) {
          this.setState({
            value: !defaultValue && defaultValue !== 0 && defaultValue !== false ? undefined : defaultValue,
            // defaultValue === undefined || defaultValue === null
            //   ? ''
            //   : defaultValue,
            result: defaultResult
          });
        }
      }
    } else {
      this.setState({
        result: defaultResult
      });
    }
  }

  onChange = (selectValue: any, option: any) => {
    const { onChange, multipleMaxNum, title = '', relatedKey = '' } = this.props;
    if (Array.isArray(selectValue) && multipleMaxNum && selectValue.length > multipleMaxNum) {
      ABSMessage.error(`最多选择${multipleMaxNum}个${title}!`);
      return;
    }

    if (!commonUtils.hasValue(this.props, 'value')) {
      this.setState({ value: selectValue }, () => {
        this.validatorValue();
      });
    }

    if (onChange) {
      onChange(selectValue, option, relatedKey);
    }
  };

  /**
   * 验证
   */
  validatorValue = () => {
    const { title, rules = [], required, value: propsValue } = this.props;
    if (!rules.length && !required) {
      return defaultResult;
    }
    let newRules = _.cloneDeep(rules);
    if (required) {
      newRules.push({ required, message: '请选择' + (title || '内容') });
    }

    const { value } = this.state;
    const result = validatorWithMsg(propsValue || value, newRules);
    this.setState({ result });
    return result;
  };

  /**
   * 重置选择器
   */
  public reset = () => {
    const { defaultValue, mode } = this.props;
    let newValue;
    if (mode) {
      newValue = defaultValue || [];
    } else {
      newValue = !defaultValue && defaultValue !== 0 && defaultValue !== false ? undefined : defaultValue;
    }
    this.setState({ value: newValue, result: defaultResult });
  };

  resetResult = () => {
    this.setState({ result: defaultResult });
  };

  getValue = (valueType?: 'int' | 'label') => {
    if (valueType === 'int') {
      return this.getIntValue();
    }
    if (valueType === 'label') {
      return this.getLabelName();
    }
    return this.state.value;
  };

  render() {
    const {
      placeholder,
      selectOptions,
      className,
      disabled,
      desc,
      mode,
      showSearch,
      titleClassName,
      removePaddingLeft,
      removeMarginBottom,
      labelWidth,
      contentWidth,
      required,
      title,
      defaultValue,
      value: propsValue,
      dropdownClassName,
      size,
      isVertical,
      isFlex
    } = this.props;
    const { value, result } = this.state;
    const newValue = commonUtils.hasValue(this.props, 'value') ? propsValue : value;
    return (
      <ABSSelectView
        value={newValue}
        onChange={this.onChange}
        disabled={disabled || false}
        dropdownMatchSelectWidth={true}
        defaultValue={defaultValue}
        desc={desc}
        title={title}
        placeholder={placeholder}
        className={className}
        size={size}
        dropdownClassName={dropdownClassName}
        selectOptions={selectOptions}
        mode={mode}
        showSearch={showSearch}
        result={result}
        titleClassName={titleClassName}
        removePaddingLeft={removePaddingLeft}
        removeMarginBottom={removeMarginBottom}
        labelWidth={labelWidth}
        contentWidth={contentWidth}
        isVertical={isVertical}
        required={required}
        isFlex={isFlex}
      />
    );
  }

  private getIntValue = () => {
    const intValue = parseInt(this.state.value, 10);
    if (isNaN(intValue)) {
      return 0;
    }
    return intValue;
  };

  private getLabelName = () => {
    const { selectOptions } = this.props;
    const { value } = this.state;
    if (!Array.isArray(selectOptions) || selectOptions.length <= 0) {
      return '';
    }
    for (const option of selectOptions) {
      if (!option) {
        continue;
      }
      const { value: sValue, labelName } = option;
      if (value === sValue) {
        return labelName;
      }
    }
    return '';
  };
}

export { IABSSelectProps };
export default ABSSelect;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ABSSelect/index.tsx